// Today's date in ISO YYYY-MM-DD form, computed at module load.
// Used as the base for relative dates throughout mock-data so fixtures
// don't fall outside list-page filter windows (e.g. subDays(new Date(), 30))
// as the calendar moves forward.
export const mockToday: string = new Date().toISOString().slice(0, 10);

// `mockToday` minus N days, same ISO YYYY-MM-DD form. Lives here rather than
// per-file so every fixture's relative dates move off the same base.
export const daysAgo = (days: number): string =>
  new Date(new Date(mockToday).getTime() - days * 86_400_000)
    .toISOString()
    .slice(0, 10);
